import React, { useState } from 'react';
import styles from './QuoteBand.module.scss';

const QuoteBand = ({ onOpenPlanner, totalProperties }) => {
  const [arrival, setArrival] = useState('');
  const [nights, setNights] = useState('5');
  const [guests, setGuests] = useState('');
  const [email, setEmail] = useState('');

  const submit = (e) => {
    e.preventDefault();
    onOpenPlanner?.({
      startDate: arrival,
      numberOfDays: nights,
      adults: guests ? Number(guests) : undefined,
      email,
    });
  };

  return (
    <>
      {/* <div className={styles.quickbar} id="quote">
        <form className={styles.qbIn} onSubmit={submit}>
          <div className={styles.qbLead}>
            <strong>Design your Safari </strong>
            <span>Operators reply within 24 hrs</span>
          </div>
          <div className={styles.qbF}>
            <label>Arrival</label>
            <input
              type="date"
              value={arrival}
              onChange={(e) => setArrival(e.target.value)}
            />
          </div>
          <div className={styles.qbF}>
            <label>Nights</label>
            <input
              type="number"
              value={nights}
              onChange={(e) => setNights(e.target.value)}
            />
          </div>
          <div className={styles.qbF}>
            <label>Guests</label>
            <input
              type="number"
              min="1"
              placeholder="2"
              value={guests}
              onChange={(e) => setGuests(e.target.value)}
            />
          </div>
          <div className={`${styles.qbF} ${styles.qbGrow}`}>
            <label>Email</label>
            <input
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <button className={styles.btn} type="submit">
            Design your Safari  →
          </button>
        </form>
      </div>
 */}
      <div className={styles.trustbar}>
        <div className={styles.tbWrap}>
          <div className={styles.tb}>
            <b>3</b>&nbsp; competing quotes per enquiry
          </div>
          <div className={styles.tb}>
            <b>{totalProperties || '100'}+</b>&nbsp;verified camps &amp; lodges
          </div>
          <div className={styles.tb}>
            replies within &nbsp;<b>24 hrs</b>
          </div>
          <div className={styles.tb}>
            <b>0% &nbsp;</b> commission &middot; no mark-up
          </div>
        </div>
      </div>
    </>
  );
};

export default QuoteBand;
